import { MemberAnketaHeader } from './MemberAnketaHeader';

export default MemberAnketaHeader;